import React from 'react';

import './Divider.css';

function Divider({ hidden }) {

    return (
        <span className={`divider${hidden ? ' hidden' : ''}`}>·</span>
    );
}

export default Divider;


// WEBPACK FOOTER //
// ./src/components/Divider.jsx